import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { chats, chatwindowDetails, initialStateModel, LoginState, rightSidePanelDetails } from "../../../models/model";
import { URInput } from "../../../shared/widgets/input";
import styles from "./scss/savedchat.module.scss";
import notesimg from "../../../styles/images/notessvg.svg";
import _ from "lodash";
import { StatusTag } from "../../../shared/widgets/statusTag";
import eventimg from "../../../styles/images/eventsvg.svg";
import taskimg from "../../../styles/images/tasksvg.svg";
import usercircle from "../../../styles/images/user-circle.svg";
import { PriorityBeam } from "../../../shared/widgets/priorityBeam";
import {
  Cookie,
  excelFormats, getFileSize, googleDriveMimeFormat, imageFormat, mp3Formats, pdfFormats, pptFormats, urlify, videoFormat,
  wordFormats, zipFormats
} from "../../../base/utils";
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import NotFound from "../../../styles/images/empty_states/savedchat_empty_state.svg";
import iconzip from "../../../styles/images/filezip.svg";
import iconpdf from "../../../styles/images/filepdf.svg";
import iconword from "../../../styles/images/fileword.svg";
import iconppt from "../../../styles/images/fileppt.svg";
import iconxls from "../../../styles/images/fileexcel.svg";
import iconarrow from "../../../styles/images/viewarrow.svg";
import iconnotsupport from "../../../styles/images/hiddenimage.svg";
import { Dropdown, Menu, Tooltip } from "antd";
import ChatLike from "../chatWidgets/chatLike";
import { SocketChatService } from "../../../base/socketChatService";
import { likeCommonFunction, memberListSearch, saveChatCommonFunction, userInfo } from "../../../base/socketChatService/utils";
import { URSavedChatSkeleton } from "../../../shared/skeletonLoading/savedChatSkeleton";
import NoContent from "../../../shared/widgets/noContent";
import { toastInformation } from "../../../base/callService/common";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import { useRef } from "react";
import { ChatService } from "../../../base/chatService";
import ChatRightInfo from "../chatWidgets/chatRightInfo";
import ChatReplyInner from "../chatWidgets/chatReplyInner";
import replyIcon from "../../../styles/images/reply-svg.svg";
import ForwardHeader from "../chatWidgets/forwardHeader";
import ChatTaskInner from "../chatWidgets/chatTaskInner";
import ChatEventsInner from "../chatWidgets/chatEventInner";
import ChatNotesInner from "../chatWidgets/chatNotesInner";
import { HighlightInner } from "../../contacts/rightsidebar/highlight";

type RightSidebarSte = {
  searchKey: string;
  savedChatRightSideList: Array<any>;
  tempList: Array<any>;
  isVisible: boolean;
  groupMemberList: Array<any>;
  searchMemberList: Array<any>;
  key: string;
  searchFilter: string;
}
type SavedChatListsRightProps = {
  chatSaved: any;
}

export default function SavedChatListsRight({ chatSaved }: SavedChatListsRightProps) {

  const rightSideLink: rightSidePanelDetails = useSelector((state: initialStateModel) =>
    state.chatRightSidePanelReducer);
  const { userdetails }: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const { chatWindowDetails }: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  const socketChat = useRef<any>(null);
  const [getItem, setItem] = useState<RightSidebarSte>({
    searchKey: '', savedChatRightSideList: [], tempList: [], isVisible: false,
    groupMemberList: chatWindowDetails.team_id ? chatWindowDetails.teammembersdetails : [userdetails, chatWindowDetails],
    searchMemberList: chatWindowDetails.team_id ? chatWindowDetails.teammembersdetails : [userdetails, chatWindowDetails], key: '',
    searchFilter: ''
  });
  const chat_reducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const [longText, setlongtext] = useState(0);

  useEffect(() => {
    const userInfo: any = Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if (userInfosess) {
      const cookieData = JSON.parse(userInfosess);
      socketChat.current = new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
    }
  }, [])


  useEffect(() => {
    setItem({ ...getItem, savedChatRightSideList: chatSaved, tempList: chatSaved });
  }, [chatSaved?.length]);

  const searchinList = (e: any) => {
    setItem({ ...getItem, searchKey: e.target.value });
  };

  const searchMemberList = (e: any) => {
    if (e.target.value !== '') {

      let filterList = memberListSearch(getItem.groupMemberList, e.target.value.toLowerCase());
      setItem({ ...getItem, groupMemberList: filterList, searchFilter: e.target.value });
    }
    else {
      setItem({ ...getItem, groupMemberList: getItem.searchMemberList, searchFilter: "" });
    }
  };

  const filterKey = (type: string) => {

    let { tempList } = getItem;
    if (type === "Today") {
      let todayDateList = _.filter(tempList, ((data: any) => {
        let thisDay = moment(data.timestamp).calendar();
        if (thisDay.includes('Today')) { return data; }
      }));
      setItem({ ...getItem, savedChatRightSideList: todayDateList, key: type, isVisible: false });
    }
    else if (type === "Yesterday") {
      let yesterdayDateList = _.filter(tempList, ((data: any) => {
        let thisDay = moment(data.timestamp).calendar();
        if (thisDay.includes('Yesterday')) { return data; }
      }));
      setItem({ ...getItem, savedChatRightSideList: yesterdayDateList, key: type, isVisible: false });
    }
    else if (type === "All") { setItem({ ...getItem, savedChatRightSideList: tempList, key: type, isVisible: false }); }

    else {
      let nameFilterList = tempList.filter((data: any) => data.fromDetails.caller_id === type);
      setItem({ ...getItem, savedChatRightSideList: nameFilterList, key: type, isVisible: false });
    }

  };


  const deleteChat = (data: any) => {
    socketChat.current.deleteForEveryone(data.id);

    let isBookmark = {
      id: data.id,
      saveStatus: 0
    };
    socketChat.current.bookMarkMesseage(isBookmark);

    toastInformation("Success! chat deleted for all", 'success');


  };

  const handlescroll = (e: any) => {

    const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;

    if (bottom && getItem.savedChatRightSideList.length > 0) {
      let fromUser = chatWindowDetails.chatId ? chatWindowDetails.chatId : chatWindowDetails.team_id;
      let savedListInput = {
        chatId: fromUser, offset: 10, orderType: 0, id: getItem.savedChatRightSideList.length > 0
          ? getItem.savedChatRightSideList[getItem.savedChatRightSideList.length - 1].id : ""
      };
      socketChat.current.savedChatlistSingleUser(savedListInput);
    }
  }

  const searchData = (str: string) => {
    let searchText = str.toLowerCase();

    return _.filter(getItem.savedChatRightSideList, function (data: any) {

      let saveMessageBody = (data?.message?.messageType === "NOTE" || data?.message?.messageType === "TASK" || data?.message?.messageType === "EVENTS") ?
        data?.message?.body?.summary?.trim() : (data?.message?.messageType === "FILE" || data?.message?.messageType === "IMAGE") ?
          (data?.message?.body?.fileName || "") : data?.message?.messageType === "GEO" ? "" : data?.message?.body;


      let sender = data.fromDetails?.caller_id || '';
      let toTeam = (data?.toDetails?.caller_id ? data?.toDetails?.caller_id : data?.toDetails?.team_name) || '';
      let dateSearch = moment(new Date(parseInt(data?.timestamp)))?.format("ddd, MMM DD YYYY") || ""
      return (((saveMessageBody)?.toLowerCase())?.includes(searchText) ||
        (sender).toLowerCase()?.includes(searchText) || (toTeam)?.toLowerCase()?.includes(searchText) ||
        (dateSearch.toString())?.toLowerCase()?.includes(searchText));
    });
  };
  let saveFinalData: any = searchData(getItem.searchKey);


  let result: any = _(saveFinalData)
    .groupBy((o: any) => (o.timestamp &&
      moment(o.timestamp).format('DD MMM YYYY')))
    .map((contacts: any, letter: any) => ({ letter, contacts })).reverse()
    .value();


  Array.isArray(result) && result.map((contactsList: any, i: any) => {

    let pr_fromuser = "";
    let pr_touser = "";
    Array.isArray(contactsList?.contacts) && contactsList?.contacts?.map((list: any, k: any) => {

      if (pr_fromuser !== list.from?.trim() || pr_touser !== list?.to?.trim()) {
        result[i].contacts[k].isHeader = true;
      } else {
        result[i].contacts[k].isHeader = false;
      }
      pr_fromuser = list?.from?.trim();
      pr_touser = list?.to?.trim();
    })
  })
  const handleChange = (flag: boolean) => {
    setItem({ ...getItem, isVisible: flag });
  }
  const openLink = (url: any) => {
    if (!url.includes("http")) url = "https://" + url;
    window.open(url);
  };
  const viewinConversation = (list: any, contact: any) => {
    if (!_.isUndefined(contact)) {
      let contactskey = Object.keys(contact);
      if (!_.isUndefined(contactskey) && contactskey.length === 1) { return; }
      else {
        var chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);
        let dataRes: any = { chatId: list?.chatId, "id": list.id }
        chatService.Savehistory(dataRes);
        setTimeout(() => {
          chatService.saveChatHighlight(true, list);
        }, 500)
        chat_reducer.isDelete && ChatService.onChangeDeleteWindow(false, '');
        chat_reducer.isForward && ChatService.onChangeForwardWindow(false, '');
        ChatService.onChangeReplyWindow(false, "");
      }
    }

  }

  const menu = (
    <Menu className="rightdropactions2" >
      <Menu.Item>
        <div className={`notesdd ${styles.dropsdowns}`} >
          <div className={`searchnotes ${styles.innerlayerssearch}`}>
            <URInput placeHolder="Search" className="leftbarsearch notes" onChange={(e: any) => searchMemberList(e)} />
          </div>

          <div className="innerlayers scroller">
            {getItem.searchFilter === "" && <> <h4>Date Created</h4>
              <ul className="datacreate">
                <li onClick={() => filterKey('All')}>All</li>
                <li onClick={() => filterKey('Today')} key={'Today'} >Today</li>
                <li onClick={() => filterKey('Yesterday')} key={'Yesterday'} >Yesterday</li>
                {/* <li key={'calender'}>calender</li>  */}
              </ul>
              <h4>Author</h4> </>}

            <ul>
              {getItem.groupMemberList.map((value: any) => {
                if (value !== null && value !== undefined) {
                  return (
                    <li key={value} onClick={() => filterKey(value?.caller_id)}>{value?.caller_id}</li>)
                }
                else { return null; }
              })} </ul>

          </div>
        </div>

      </Menu.Item>


    </Menu>
  );
  const readMoreChange = () => {
    setlongtext(1);
  }
  return (
    <>
      <div className={`fadeIn ${styles.savedchatmain}`}>
        <div className={styles.rightbartop}>
          <div className={styles.savedchatnewbtn}>
            <span className={styles.titleText}>Saved</span>
          </div>

          {rightSideLink.savedListDetails.length > 0 && <div className={styles.savedchatsearchbar}>
            <div className={styles.lefts}>
              <URInput placeHolder="Search" className="rightbarsearch" onChange={(e: any) => searchinList(e)} />
            </div>
            <div className={styles.rights}>
              <Dropdown className="popss2" trigger={['click']} overlay={menu} visible={getItem.isVisible}

                onVisibleChange={handleChange} placement="bottomRight">
                <p>{getItem.key === "" ? 'All' : getItem.key}
                  <span className={`icon_down-arrow menudroprotate`}></span>
                </p>

              </Dropdown>
            </div>
          </div>}
        </div>
        {!rightSideLink.isSavedList ?
          [1, 2, 3, 4, 5, 6].map((data: any) => (
            <div className={styles.skeletonSec} key={data}>
              <URSavedChatSkeleton key={data} />
            </div>
          )) :
          ((rightSideLink.isSavedList && getItem.savedChatRightSideList.length === 0) || result.length === 0) && <NoContent image={NotFound}
            title={"Worktual Saved Chats"}
            description={<>Let us refresh your memory. Save all your important<br />
              conversations here.</>} />}


        <div className={`scroller ${styles.rightbarbottom}`} onScroll={handlescroll}>

          {result && Array.isArray(result) && result.reverse().map((contactsDetails: any, index: any) => {


            return (
              <Fragment key={index}>
                {Array.isArray(contactsDetails.contacts) && contactsDetails.contacts && contactsDetails.contacts.length > 0 ?
                  contactsDetails.contacts.map((saveddata: any, i: any) => {
                    let redirectUsr: any = userdetails?.sip_login_id === saveddata?.to ? saveddata?.fromDetails : saveddata?.toDetails;
                    let isBookmark: any = saveddata?.message?.isSave || [];
                    let LikeObeject: any = saveddata?.message?.liked || [];
                    let isLike = (LikeObeject && LikeObeject['s' + userdetails?.sip_login_id]) || 0;
                    let savedBookmark = (isBookmark && isBookmark['s' + userdetails?.sip_login_id]) || 0;
                    let mstext: any = saveddata?.message?.body;
                    if (mstext?.length > 200 && longText === 0) {
                      mstext = mstext.substring(0, 200) + "...";
                    }
                    //console.log(saveddata, "opopo")
                    // if (saveddata.toDetails?.team_id) {
                    //   teamMemberarrayforImage = saveddata.toDetails?.team_id && saveddata.toDetails?.team_members &&
                    //   saveddata.toDetails?.team_members.replaceAll(" ", "").split(',');
                    //   teamMemberarrayforImage?.map((list: any) => {
                    //     let c_details = getcontactDetail(list);
                    //     teamMemberNames.push(c_details?.caller_id);
                    //   });
                    // }

                    let fileName = '';
                    let filesize = '';
                    let fileTypes = '';
                    let filePath = '';
                    let isCloudfiles = false;
                    if (saveddata?.message?.messageType !== "TEXT" && (saveddata?.message?.messageType === "FILE" || saveddata?.message?.messageType === "IMAGE")) {
                      let messageBody = saveddata?.message?.body;
                      // let fileName = messageBody?.fileName;
                      fileName =messageBody?.fileName.length > 40 ? messageBody?.fileName.substring(0, 39) + "..." : messageBody?.fileName;
                      filesize = messageBody?.filesize;
                      fileTypes = messageBody?.fileType;
                      filePath = messageBody?.filePath;
                      isCloudfiles = messageBody?.isCloudfiles
                    }

                    let currentDate = moment(saveddata?.timestamp).calendar().includes('Today')
                      ? moment(saveddata?.timestamp).calendar()
                      : moment(saveddata?.timestamp).calendar().includes('Yesterday') ?
                        moment(saveddata?.timestamp).calendar() :
                        moment(saveddata?.timestamp).format("DD MMM") + " at " + moment(saveddata?.timestamp).format("hh:mm A");
                    let size = filesize && getFileSize(filesize);
                    return (
                      <Fragment key={i}>
                        <div className={`/*${styles.active}*/ ${styles.savedchatlist}`}>

                          {saveddata.isHeader ? (

                            <div className={styles.toplayer}>

                              <h3>{userdetails?.caller_id === saveddata?.fromDetails?.caller_id
                                ? "You" :
                                saveddata?.fromDetails?.caller_id?.length <= 15 ?
                                  saveddata?.fromDetails?.caller_id :
                                  saveddata?.fromDetails?.caller_id?.substring(0, 15) + "..."}
                                <span className="icon_strokearrowright"></span>

                                <b>{userdetails?.caller_id === saveddata?.toDetails?.caller_id ?
                                  "You" : saveddata?.toDetails?.team_id ?
                                    saveddata?.toDetails?.team_name?.length <= 15
                                      ? saveddata?.toDetails?.team_name :
                                      saveddata?.toDetails?.team_name?.substring(0, 15) + "..." :
                                    saveddata?.toDetails?.caller_id?.length <= 10 ?
                                      saveddata?.toDetails?.caller_id :
                                      saveddata?.toDetails?.caller_id?.substring(0, 15) + "..."}</b>

                                <span className={styles.dates}>{moment(saveddata?.timestamp).format("D MMM")}</span>
                              </h3>
                            </div>
                          ) : null

                          }




                          <div className={userdetails?.sip_login_id === saveddata?.from
                            ? `${styles.topbottomlayer} messageOut` : `${styles.topbottomlayer} messagein`}>
                            {/* <div className={styles.lefts}>
                              <span className="icon_ribbon"></span><br />
                              <Tooltip mouseEnterDelay={0.5} placement="top" title={currentDate} >
                                <span className={styles.timeHover}>
                                  {moment(saveddata?.timestamp).format('hh:mm')}
                                </span>
                              </Tooltip>
                            </div> */}
                            <div className={styles.hoverdiv}>
                              <ul>

                                <li onClick={() => likeCommonFunction(isLike === 0 ? 1 : 0, saveddata)} ><Tooltip mouseEnterDelay={0.5} placement="top"
                                  title={isLike === 0 ? 'Like' : 'Unlike'} className={styles.likeBtn}>
                                  <span className="icon_Like"></span></Tooltip></li>

                                <li onClick={() => saveChatCommonFunction(savedBookmark === 0 ? 1 : 0, saveddata)} className={styles.savedBtn}>
                                  <Tooltip mouseEnterDelay={0.5} placement="top" title={savedBookmark === 0 ? 'Save Chat' : 'UnSave chat'}>
                                    <span className="icon_savechatsill"></span></Tooltip></li>

                                {(saveddata?.message?.messageType === 'TEXT' || saveddata?.message?.messageType === 'FILE' || saveddata?.message?.messageType === 'IMAGE'
                                  || saveddata?.message?.messageType === 'MENTION') && userdetails?.caller_id === saveddata?.fromDetails?.caller_id && <li onClick={() => deleteChat(saveddata)} className={styles.delBtn}><Tooltip mouseEnterDelay={0.5} placement="top" title="Delete chat">
                                    <span className="icon_delete"></span></Tooltip></li>}
                              </ul>
                            </div>
                            {saveddata?.message?.forward && <ForwardHeader />}
                            {saveddata?.message?.isReply && <div className={styles.savedreplyChat}>
                              <div className={styles.replyHeader}>
                                {/* <img src={replyIcon} alt="" /> */}
                                <span className={styles.iconReply}></span>
                                <span className="">Replied</span>
                              </div>
                              <div className={styles.replyTopSec}>
                                <ChatReplyInner isBottom={false} replyingMessage={saveddata?.message?.replyMsgBody} />
                              </div>
                            </div>}
                            {saveddata?.message?.messageType === "NOTE" ? <>
                            <ChatNotesInner notesData={saveddata?.message?.body} searchedData={''}/>
                              {/* <div className={styles.noteshort} onClick={() => viewinConversation(saveddata, redirectUsr)}>
                                <img src={notesimg} alt="" />
                                <div className={styles.filesDetails}>
                                  <span className={styles.fileName}>
                                    {saveddata?.message?.body?.summary.length > 13 ?
                                      saveddata?.message?.body?.summary.substring(0, 11) + "..." : saveddata?.message?.body?.summary}
                                  </span>
                                  <span className={styles.fileDt}>Created on {saveddata?.message?.body?.lastModified
                                    && moment(new Date(parseInt(saveddata?.message?.body?.lastModified))).format('ll')}</span>
                                </div>
                              </div> */}
                            </> : saveddata.message.messageType === "EVENTS" ? <>
                            <ChatEventsInner eventData={saveddata?.message?.body} searchedData={''} viewData={''}/>
                              {/* <div className={styles.eventsMessage} onClick={() => viewinConversation(saveddata, redirectUsr)}>
                                <span className={styles.eventsCreated}><img src={eventimg} alt="" /></span>
                                <div className={styles.eventsHeader}>
                                  <div className={styles.eventsStatus}>
                                    <span className={styles.eventsTitle}>{saveddata?.message?.body?.summary?.length > 13 ?
                                      saveddata?.message?.body?.summary.substring(0, 11) + "..." : saveddata?.message?.body?.summary}</span>
                                  </div>
                             
                                  <div className={styles.reviewBtn}>
                                    <span className={styles.eventsDate}>
                                      {moment(saveddata?.message?.body?.timestamp).format('ll')} </span>
                                    <StatusTag className='statusunderReview' name='In Review' />
                                  </div>
                                </div>
                              </div> */}

                            </> : saveddata.message.messageType === "TASK" ? <>
                              <ChatTaskInner taskData={saveddata?.message?.body} searchedData={''} viewData={""} />

                              {/* <div className={`${styles.taskMessage}`} onClick={() => viewinConversation(saveddata, redirectUsr)}> */}
                              {/* <span className={styles.taskCreated}><img src={taskimg} alt="" /></span>
                                <div className={styles.taskHeader}>
                                  <div className={styles.taskStatus}>
                                    <span className={styles.taskTitle}>{saveddata?.message?.body?.summary.length > 13 ?
                                      saveddata?.message?.body?.summary.substring(0, 11) + "..." : saveddata?.message?.body?.summary}</span>
                                    {saveddata?.message?.body?.attendee.length > 0 &&
                                      <span className={styles.userCount}>{saveddata?.message?.body?.attendee.length}
                                        <img src={usercircle} alt="" /></span>}
                                  </div>
                                  <div className={styles.taskDetails}>
                                    <PriorityBeam className={saveddata?.message?.body?.priority === "High" ? 'priorityBeam bgRed' : saveddata?.message?.body?.priority === "Medium" ?
                                      'priorityBeam bgYello' : 'priorityBeam bgGreen'} />
                                    <span className={styles.taskDate}>
                                      {moment((saveddata?.message?.body?.dtend) * 1000).format('ll')}
                                    </span>
                                    <div className={styles.reviewBtn}>
                                      {saveddata?.message?.body?.creatorStatus === "In Review" || saveddata.message.body?.taskStatus === "In Review" ||
                                        saveddata?.message?.body?.recurOptions === "In Review" ?
                                        <StatusTag className='statusunderReview' name='In Review' />
                                        : saveddata?.message?.body?.creatorStatus === "On Hold" || saveddata.message.body?.taskStatus === "On Hold" ||
                                          saveddata?.message?.body?.recurOptions === "On Hold" ?
                                          <StatusTag className='statusHold' name='On Hold' /> :
                                          saveddata?.message?.body?.creatorStatus === "Completed" || saveddata.message.body?.taskStatus === "Completed" ||
                                            saveddata?.message?.body?.recurOptions === "Completed" ?
                                            <StatusTag className='statusCompleted' name='Completed' /> :
                                            <StatusTag className='statusunderinProgress' name='In Progress' />
                                      }
                                    </div>
                                  </div>

                                </div> */}
                              {/* </div> */}
                            </> :
                              (saveddata?.message?.messageType === "FILE" || saveddata?.message?.messageType === "IMAGE") &&
                                videoFormat.indexOf(fileTypes) !== -1 && !isCloudfiles ? <>
                                <div className={styles.imageChat}>
                                  <div className={styles.imageList}>
                                    <div className={styles.imageSec} onClick={() => viewinConversation(saveddata, redirectUsr)}>
                                      <video controls>
                                        <source src={filePath} type="video/mp4" />
                                      </video>
                                    </div>
                                  </div>
                                </div>
                              </> :
                                (saveddata?.message?.messageType === "IMAGE" && saveddata?.message?.isLink === true) &&
                                  imageFormat.indexOf(fileTypes) !== -1 && !isCloudfiles ? <>
                                  <div className={styles.imageChat}>
                                    <div className={styles.imageList}>
                                      <div className={styles.imageSec} onClick={() => viewinConversation(saveddata, redirectUsr)}>
                                        <img src={filePath} alt="" /></div>
                                    </div>
                                    <p onClick={() => openLink(saveddata?.message?.body && saveddata?.message?.body?.text)}
                                      dangerouslySetInnerHTML={{ __html: urlify(saveddata?.message?.body) }}
                                    >
                                    </p>
                                  </div>
                                </> :
                                  saveddata?.message?.messageType === "IMAGE" &&
                                    imageFormat.indexOf(fileTypes) !== -1 && !isCloudfiles  ? <>
                                    <div className={styles.imageChat}>
                                      <div className={styles.imageList}>
                                        <div className={styles.imageSec} onClick={() => viewinConversation(saveddata, redirectUsr)}>
                                          <img src={filePath} alt="" /></div>
                                      </div>
                                    </div></> :
                                    saveddata?.message?.messageType === "FILE" &&
                                      mp3Formats.indexOf(fileTypes) !== -1 && !isCloudfiles ? <>
                                      <div className={styles.audioChat} onClick={() => viewinConversation(saveddata, redirectUsr)}>
                                        <div className={styles.audioImage}>
                                          <div className={styles.convIcon}>


                                            <URAvatarGroup className='lefts size38'
                                              profileInfo={
                                                (saveddata?.fromDetails?.profile_url) ?
                                                  <>
                                                    <img src={saveddata?.fromDetails?.profile_url} alt="" />
                                                  </> :
                                                  (saveddata?.fromDetails?.ImageURL) ?
                                                    <>
                                                      <img src={saveddata?.fromDetails?.ImageURL} alt="" />
                                                    </> :
                                                    (<>
                                                      <span>{saveddata?.fromDetails?.caller_id?.charAt(0).toUpperCase()} </span>

                                                    </>)

                                              } />

                                          </div>
                                        </div>
                                        <div className={styles.audioDetails}>
                                          <div className="audioNew">
                                            <AudioPlayer
                                              src={filePath}
                                              customIcons={{
                                                play: <span className="icon_play"></span>,
                                                pause: <span className="icon_pausebar"></span>
                                              }}
                                              customProgressBarSection={
                                                [
                                                  RHAP_UI.MAIN_CONTROLS,
                                                  RHAP_UI.PROGRESS_BAR

                                                ]
                                              }
                                              customControlsSection={
                                                [
                                                  <div key={i}>Audio</div>,
                                                  RHAP_UI.DURATION
                                                ]
                                              }
                                              timeFormat='mm:ss'
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </> :
                                      (saveddata.message.messageType === "FILE" || saveddata.message.messageType === "IMAGE") &&
                                        imageFormat.indexOf(fileTypes) === -1
                                        && videoFormat.indexOf(fileTypes) === -1 &&
                                        mp3Formats.indexOf(fileTypes) === -1
                                        ? <>
                                          <div className={styles.chatAttachmentList} onClick={() => viewinConversation(saveddata, redirectUsr)}>
                                            {zipFormats.indexOf(fileTypes) !== -1 &&
                                              <div className={`msgAttach ${styles.filesChat}`}>
                                                <div className={styles.filesImage}><img src={iconzip} alt="filename" /></div>
                                                <div className={styles.filesDetails}>
                                                  <span className={styles.fileName}>
                                                  <HighlightInner content={fileName}
                                                                  searchedData={getItem.searchKey}></HighlightInner>
                                                    {/* {fileName.length > 12 ? fileName.substring(0, 13) + "..." : fileName} */}
                                                    </span>
                                                  <span className={styles.fileDt}>{size + " Zip"}</span>
                                                  {isCloudfiles && <span className={styles.fileDt}>{filePath.includes('https://app.box.com') ? ' File from Box'  : " File from Drive"}</span>}
                                                </div>
                                              </div>}
                                            {pdfFormats.indexOf(fileTypes) !== -1 &&
                                              <div className={`msgAttach ${styles.filesChat}`}>
                                                <div className={styles.filesImage}><img src={iconpdf} alt="filename" /></div>
                                                <div className={styles.filesDetails}>
                                                  <span className={styles.fileName}>
                                                  <HighlightInner content={fileName}
                                                                  searchedData={getItem.searchKey}></HighlightInner>
                                                    {/* {fileName.length > 12 ? fileName.substring(0, 13) + "..." : fileName} */}
                                                    </span>
                                                  <span className={styles.fileDt}>{size + " Pdf"}</span>
                                                  {isCloudfiles && <span className={styles.fileDt}>{filePath.includes('https://app.box.com') ? ' File from Box'  : " File from Drive"}</span>}
                                                </div>
                                              </div>}
                                            {(wordFormats.indexOf(fileTypes) !== -1 || fileTypes.includes('plain') || fileTypes.includes('html')) &&
                                              <div className={`msgAttach ${styles.filesChat}`}>
                                                <div className={styles.filesImage}><img src={iconword} alt="filename" /></div>
                                                <div className={styles.filesDetails}>
                                                  <span className={styles.fileName}>
                                                  <HighlightInner content={fileName}
                                                                  searchedData={getItem.searchKey}></HighlightInner>
                                                    {/* {fileName.length > 12 ? fileName.substring(0, 13) + "..." : fileName} */}
                                                    </span>
                                                  <span className={styles.fileDt}>{size + " Word Document"}</span>
                                                  {isCloudfiles && <span className={styles.fileDt}>{filePath.includes('https://app.box.com') ? ' File from Box'  : " File from Drive"}</span>}
                                                </div>
                                              </div>}
                                            {pptFormats.indexOf(fileTypes) !== -1 &&
                                              <div className={`msgAttach ${styles.filesChat}`}>
                                                <div className={styles.filesImage}><img src={iconppt} alt="filename" /></div>
                                                <div className={styles.filesDetails}>
                                                  <span className={styles.fileName}>
                                                  <HighlightInner content={fileName}
                                                                  searchedData={getItem.searchKey}></HighlightInner>
                                                    {/* {fileName.length > 12 ? fileName.substring(0, 13) + "..." : fileName} */}
                                                    </span>
                                                  <span className={styles.fileDt}>{size + " Ppt"}</span>
                                                  {isCloudfiles && <span className={styles.fileDt}>{filePath.includes('https://app.box.com') ? ' File from Box'  : " File from Drive"}</span>}
                                                </div>

                                              </div>}
                                            {excelFormats.indexOf(fileTypes) !== -1 &&
                                              <div className={`msgAttach ${styles.filesChat}`}>
                                                <div className={styles.filesImage}><img src={iconxls} alt="filename" /></div>
                                                <div className={styles.filesDetails}>
                                                  <span className={styles.fileName}>
                                                  <HighlightInner content={fileName}
                                                                  searchedData={getItem.searchKey}></HighlightInner>
                                                    {/* {fileName.length > 12 ? fileName.substring(0, 13) + "..." : fileName} */}
                                                    </span>
                                                  <span className={styles.fileDt}>{size + " Excel"}</span>
                                                  {isCloudfiles && <span className={styles.fileDt}>{filePath.includes('https://app.box.com') ? ' File from Box'  : " File from Drive"}</span>}
                                                </div>

                                              </div>}
                                              { (googleDriveMimeFormat.indexOf(fileTypes) !== -1  || fileTypes === 'application/x-msdownload' ) && 
                                                 <div className={`msgAttach ${styles.filesChat}`}>
                                                 <div className={styles.filesImage}><img src={iconnotsupport} alt="filename" /></div>
                                                 <div className={styles.filesDetails}>
                                                   <span className={styles.fileName}>
                                                    {/* {fileName.length > 12 ? fileName.substring(0, 13) + "..." : fileName} */}
                                                    <HighlightInner content={fileName}
                                                                  searchedData={getItem.searchKey}></HighlightInner>
                                                    </span>
                                                   <span className={styles.fileDt}>{size}</span>
                                                   {isCloudfiles && <span className={styles.fileDt}>{filePath.includes('https://app.box.com') ? ' File from Box'  : " File from Drive"}</span>}
                                                 </div>
 
                                               </div>
                                              }
                                          </div>
                                        </> :
                                        saveddata?.message?.isLink ?
                                          <p onClick={() => openLink(saveddata?.message?.body && saveddata?.message?.body)}
                                            dangerouslySetInnerHTML={{ __html: urlify(saveddata?.message?.body) }}
                                          >
                                            {/* <HighlightInner content={saveddata?.message?.body}
                                                                  searchedData={getItem.searchKey}></HighlightInner> */}
                                          </p>
                                          // <p  className={styles.linkText} onClick={()=>viewinConversation(saveddata,redirectUsr)}>
                                          // {saveddata?.message?.body && saveddata?.message?.body} </p>
                                          :
                                          (saveddata.message.messageType === "FILE" || saveddata.message.messageType === "IMAGE") &&
                                          ( imageFormat.indexOf(fileTypes) !== -1 || 
                                          videoFormat.indexOf(fileTypes) !== -1 ||
                                          mp3Formats.indexOf(fileTypes) !== -1) && isCloudfiles ?
                                          <div className={styles.chatAttachmentList} onClick={() => viewinConversation(saveddata, redirectUsr)}>
                                          <div className={`msgAttach ${styles.filesChat}`}>
                                            <div className={styles.filesImage}><img src={iconnotsupport} alt="filename" /></div>
                                            <div className={styles.filesDetails}>
                                              <span className={styles.fileName}>
                                              <HighlightInner content={fileName}
                                                                  searchedData={getItem.searchKey}></HighlightInner>
                                                {/* {fileName.length > 12 ? fileName.substring(0, 13) + "..." : fileName} */}
                                                </span>
                                              {/* <span className={styles.fileDt}>{size + " Excel"}</span> */}
                                              {isCloudfiles && <span className={styles.fileDt}>{filePath.includes('https://app.box.com') ? ' file from Box '  : " file from Drive"}</span>}
                                            </div>
                                          </div>
                                          </div> 
                                          :

                                          saveddata.message.messageType === "GEO" ?
                                            <p className={styles.contentTxt}> this is geoLocation Message type</p> :
                                            <>
                                              {mstext?.length > 200 && longText === 0 &&
                                                <span className={styles.savedChatTxt}>
                                                  {/* {mstext} */}
                                                  <HighlightInner content={mstext}
                                                                  searchedData={getItem.searchKey}></HighlightInner>
                                                  {mstext?.length > 200 && longText === 0 && <span className="chatReadMore" onClick={() => readMoreChange()}>Read more</span>}
                                                </span>}
                                              {(mstext?.length < 200 || longText === 1) && 
                                              <p className={styles.messageText} 
                                              onClick={() => viewinConversation(saveddata, redirectUsr)}
                                              //  dangerouslySetInnerHTML={{ __html: saveddata.message.body }}
                                              >
                                                 <HighlightInner content={mstext}
                                                                 searchedData={getItem.searchKey}></HighlightInner>
                                                </p>}

                                            </>

                              // <p dangerouslySetInnerHTML={{ __html: saveddata.message.body}}></p>
                            }
                            <div className={styles.userInfo}>
                              {saveddata.message.messageType === "TASK" && <span className={styles.tasksChatContent}>
                                {saveddata?.message?.isEdit ? "You updated the Task" : "You created a new Task"}
                              </span> }
                              {saveddata.message.messageType === "EVENTS" && <span className={styles.tasksChatContent}>
                                {saveddata?.message?.isEdit ? "You updated the Event" : "You created a new Event"}
                              </span> }
                              {saveddata.message.messageType === "NOTE" && <span className={styles.tasksChatContent}>
                                {saveddata?.message?.isEdit ? "You updated the Note" : "You created a new Note"}
                              </span> }
                              { isCloudfiles && <img className={styles.arrowlink} src={iconarrow} onClick={()=> {window.open(filePath)}} alt='save'/>}
                              <span className="icon_ribbonfill"></span><br />
                              <Tooltip mouseEnterDelay={0.5} placement="top" title={currentDate} >
                                <span className={styles.timeText}>
                                  {moment(saveddata?.timestamp).format('hh:mm')}
                                </span>
                              </Tooltip>
                            </div>
                          </div>
                          <span className={styles.likeIcon}><ChatLike className='likeLeft likeSaved' tooltipTitle={saveddata} message={saveddata} /></span>
                        </div>

                      </Fragment>
                    );

                  }) : null}
              </Fragment>
            )
          })}
        </div>
      </div>


    </>
  );
};

